import { render } from "./AddNewNote.vue?vue&type=template&id=d6516dde&ts=true"
import script from "./AddNewNote.vue?vue&type=script&lang=ts"
export * from "./AddNewNote.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__